import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiputFormData } from '../../../API/Api_Url';

function LabourProfileUpdate({ ProUserdata, ChangeTab, GetUserProfile }) {
    const [isUploading, setIsUploading] = useState(false);

    const [fullName, setFullName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [city, setCity] = useState('');
    const [location, setLocation] = useState('');
    const [additionalNotes, setAdditionalNotes] = useState('');
    const [subRole, setSubRole] = useState('');
    const [mainSkill, setMainSkill] = useState('');

    const [preferredJobLocations, setPreferredJobLocations] = useState([]);
    const [bankDetails, setBankDetails] = useState({
        AccountHolderName: '',
        BankName: '',
        AccountNumber: '',
        IFSCCode: '',
        BranchName: '',
        UPIId: ''
    });
    const [residentialAddress, setResidentialAddress] = useState({
        temporary: '',
        permanent: ''
    });

    useEffect(() => {
        if (!ProUserdata) return;

        setFullName(ProUserdata.fullName || '');
        setCompanyName(ProUserdata.companyName || '');
        setEmailAddress(ProUserdata.emailAddress || '');
        setPhoneNumber(ProUserdata.phoneNumber || '');
        setCity(ProUserdata.City || '');
        setLocation(ProUserdata.Location || '');
        setAdditionalNotes(ProUserdata.additionalNotes || '');
        setSubRole(ProUserdata.SubRole || '');
        setMainSkill(ProUserdata.mainSkill || '');
        setPreferredJobLocations(ProUserdata.preferredJobLocations || []);
        setBankDetails(ProUserdata.Bankdetails || {});
        setResidentialAddress(ProUserdata.residentialAddress || { temporary: '', permanent: '' });
    }, [ProUserdata]);

    const handleUpdateProfile = async () => {
        try {
            setIsUploading(true);

            const formData = new FormData();

            formData.append('fullName', fullName);
            formData.append('companyName', companyName);
            formData.append('emailAddress', emailAddress);
            formData.append('phoneNumber', phoneNumber);
            formData.append('City', city);
            formData.append('Location', location);
            formData.append('additionalNotes', additionalNotes);
            formData.append('SubRole', subRole);
            formData.append('mainSkill', mainSkill);

            preferredJobLocations.forEach((loc, idx) => {
                formData.append(`preferredJobLocations[${idx}]`, loc);
            });

            Object.keys(bankDetails).forEach((key) => {
                formData.append(`Bankdetails[${key}]`, bankDetails[key]);
            });

            Object.keys(residentialAddress).forEach((key) => {
                formData.append(`residentialAddress[${key}]`, residentialAddress[key]);
            });

            const response = await apiputFormData('api/labour/update', formData);

            if (response?.data) {
                toast.success('Profile updated successfully!');
                GetUserProfile();
                ChangeTab('Profile');
            } else {
                toast.error(response?.message || 'Failed to update profile');
            }
        } catch (err) {
            console.error('Update error:', err);
            toast.error('Error updating profile. See console for details.');
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="mx-auto space-y-6 p-4">
            <section className="bg-white shadow-xl rounded-2xl p-8 border border-gray-100">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">Edit Labour Profile</h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <InputField label="Full Name" value={fullName} setValue={setFullName} />
                    <InputField label="Company Name" value={companyName} setValue={setCompanyName} />
                    <InputField label="Email Address" value={emailAddress} setValue={setEmailAddress} type="email" />
                    <InputField label="Mobile Number" value={phoneNumber} setValue={setPhoneNumber} type="tel" />
                    <InputField label="City" value={city} setValue={setCity} />
                    <InputField label="Location" value={location} setValue={setLocation} />
                    <InputField label="Sub Role" value={subRole} setValue={setSubRole} />
                    <InputField label="Main Skill" value={mainSkill} setValue={setMainSkill} />
                </div>

                <div className="mt-6">
                    <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                        Preferred Job Locations (comma separated)
                    </label>
                    <input
                        type="text"
                        value={preferredJobLocations.join(', ')}
                        onChange={(e) =>
                            setPreferredJobLocations(e.target.value.split(',').map((v) => v.trim()))
                        }
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <InputField
                        label="Temporary Address"
                        value={residentialAddress.temporary}
                        setValue={(val) => setResidentialAddress({ ...residentialAddress, temporary: val })}
                    />
                    <InputField
                        label="Permanent Address"
                        value={residentialAddress.permanent}
                        setValue={(val) => setResidentialAddress({ ...residentialAddress, permanent: val })}
                    />
                </div>

                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object?.keys(bankDetails)?.map((key) => (
                        <InputField
                            key={key}
                            label={key}
                            value={bankDetails[key]}
                            setValue={(val) => setBankDetails({ ...bankDetails, [key]: val })}
                        />
                    ))}
                </div>

                <div className="mt-6">
                    <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                        Additional Notes
                    </label>
                    <textarea
                        value={additionalNotes}
                        onChange={(e) => setAdditionalNotes(e.target.value)}
                        rows={3}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                <div className="mt-8 pt-6 border-t border-gray-200 flex gap-3 items-center">
                    <button
                        onClick={handleUpdateProfile}
                        disabled={isUploading}
                        className="px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg shadow-md hover:from-blue-600 hover:to-blue-700 transition-all duration-200"
                    >
                        {isUploading ? 'Updating...' : 'Save Changes'}
                    </button>

                    <button
                        onClick={() =>
                            typeof ChangeTab === 'function' ? ChangeTab('Profile') : null
                        }
                        className="px-4 py-2 border rounded-lg"
                    >
                        Cancel
                    </button>
                </div>
            </section>
        </div>
    );
}

const InputField = ({ label, value, setValue, type = 'text' }) => (
    <div>
        <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
            {label}
        </label>
        <input
            type={type}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
    </div>
);

export default LabourProfileUpdate;
